/* import __COLOCATED_TEMPLATE__ from './filter-tags.hbs.js'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import { service } from '@ember/service';
import { findById } from 'ilios-common/utils/array-helpers';
import { TrackedAsyncData } from 'ember-async-data';
let DashboardFilterTagsComponent = (_class = class DashboardFilterTagsComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
  }
  get activeFilters() {
    return [].concat(this.args.selectedSessionTypeIds || [], this.args.selectedCourseLevels || [], this.args.selectedCohortIds || [], this.args.selectedCourseIds || [], this.args.selectedTermIds || []);
  }
  get filterTags() {
    return [...this.courseLevelTags, ...this.sessionTypeTags, ...this.cohortTags, ...this.termTags, ...this.courseTags];
  }
  async fetchModel(modelName, id) {
    const model = this.store.peekRecord(modelName, id);
    return model ? model : this.store.findRecord(modelName, id);
  }
  get courseLevelTags() {
    return this.args.selectedCourseLevels.map(level => {
      return {
        id: level,
        class: 'tag-course-level',
        remove: this.args.removeCourseLevel,
        name: this.intl.t('general.courseLevel', {
          level
        })
      };
    });
  }
  get sessionTypeTagsData() {
    return new TrackedAsyncData(Promise.all(this.args.selectedSessionTypeIds.map(async id => {
      const sessionType = await this.fetchModel('session-type', id);
      return {
        id,
        class: 'tag-session-type',
        remove: this.args.removeSessionTypeId,
        name: sessionType.title
      };
    })));
  }
  get sessionTypeTags() {
    return this.sessionTypeTagsData.isResolved ? this.sessionTypeTagsData.value : [];
  }
  get cohortTags() {
    return this.args.selectedCohortIds.map(id => {
      const proxy = findById(this.args.cohortProxies, id);
      return {
        id,
        class: 'tag-cohort',
        remove: this.args.removeCohortId,
        name: `${proxy.displayTitle} ${proxy.programTitle}`
      };
    });
  }
  get termTagsData() {
    return new TrackedAsyncData(Promise.all(this.args.selectedTermIds.map(async id => {
      const term = await this.fetchModel('term', id);
      const allTitles = await term.getTitleWithParentTitles();
      const vocabulary = await term.vocabulary;
      const title = vocabulary.get('title');
      return {
        id,
        class: 'tag-term',
        remove: this.args.removeTermId,
        name: `${title} > ${allTitles}`
      };
    })));
  }
  get termTags() {
    return this.termTagsData.isResolved ? this.termTagsData.value : [];
  }
  get courseTagsData() {
    return new TrackedAsyncData(Promise.all(this.args.selectedCourseIds.map(async id => {
      const course = await this.fetchModel('course', id);
      return {
        id,
        class: 'tag-course',
        remove: this.args.removeCourseId,
        name: `${course.year} ${course.title}`
      };
    })));
  }
  get courseTags() {
    return this.courseTagsData.isResolved ? this.courseTagsData.value : [];
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "sessionTypeTagsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "sessionTypeTagsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "termTagsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "termTagsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "courseTagsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "courseTagsData"), _class.prototype), _class);
export { DashboardFilterTagsComponent as default };